var moduleMap = {
	"./HostState": () => {
		return Promise.all([__webpack_require__.e(967), __webpack_require__.e(310), __webpack_require__.e(96), __webpack_require__.e(120), __webpack_require__.e(137), __webpack_require__.e(374), __webpack_require__.e(331), __webpack_require__.e(857)]).then(() => (() => ((__webpack_require__(2857)))));
	},
	"./HistoryContext": () => {
		return Promise.all([__webpack_require__.e(967), __webpack_require__.e(310), __webpack_require__.e(96), __webpack_require__.e(120), __webpack_require__.e(137), __webpack_require__.e(374), __webpack_require__.e(331)]).then(() => (() => ((__webpack_require__(84331)))));
	},
	"./GradientText": () => {
		return Promise.all([__webpack_require__.e(967), __webpack_require__.e(120), __webpack_require__.e(444)]).then(() => (() => ((__webpack_require__(90444)))));
	},
	"./PlatformSDK": () => {
		return Promise.all([__webpack_require__.e(967), __webpack_require__.e(239), __webpack_require__.e(310), __webpack_require__.e(96), __webpack_require__.e(120), __webpack_require__.e(137), __webpack_require__.e(374), __webpack_require__.e(331), __webpack_require__.e(69)]).then(() => (() => ((__webpack_require__(73069)))));
	},
	"./Sensors": () => {
		return Promise.all([__webpack_require__.e(310), __webpack_require__.e(192)]).then(() => (() => ((__webpack_require__(32192)))));
	},
	"./Loading": () => {
		return Promise.all([__webpack_require__.e(967), __webpack_require__.e(120), __webpack_require__.e(137), __webpack_require__.e(374), __webpack_require__.e(314)]).then(() => (() => ((__webpack_require__(31314)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};


// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});